if (!customElements.get("variant-selects")) {
    /**
     *  @class
     *  @function VariantSelects
     */
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.mainProductFetch();
        this.isDisabledFeature = this.dataset.isDisabled;
        this.updateUrl = this.dataset.updateUrl === "true";
        this.addEventListener("change", this.onVariantChange);
        const self = this;
        
        document
          .querySelectorAll(
            ".varient-selection-size-label"
          )
          .forEach(function (element) {
            element.addEventListener("click", function (event) {
              if (
                event.target.classList.contains("varient-selection-size-label")
              ) {
                const hiddenInput = document.getElementById(
                  "selected-variant-id"
                );
                const dataId = event.target.getAttribute("data-id");
                const selectedVariantId = dataId;
                hiddenInput.value = selectedVariantId;
                const changeEvent = new Event("change");
                hiddenInput.dispatchEvent(changeEvent);
              }
            });
          });
        
        const select = document.getElementById("option-select-2");
        if (select) {
          select.addEventListener("change", function (event) {
            self.updateSelectedVariant(event.target);
          });
        }
        this.productWrapper = this.closest(".thb-product-detail");
        this.productSlider = this.productWrapper.querySelector(".product-images");
        this.hideVariants = this.dataset.hideVariants === "true";
        this.updateProductVariant = this.updateProductVariant.bind(this);
      }
      updateSelectedVariant(selectElement) {
        const selectedOption = selectElement.options[selectElement.selectedIndex];
        const dataId = selectedOption.getAttribute("data-id");
  
        const hiddenInput = document.getElementById("selected-variant-id");
        hiddenInput.value = dataId;
  
        document.querySelector(".product-sku span.sku-value").innerHTML = selectedOption.getAttribute("data-sku");
  
        // Dispatch change event if necessary
        const changeEvent = new Event("change");
        hiddenInput.dispatchEvent(changeEvent);
      }
  
      connectedCallback() {
        this.updateOptions();
        this.updateMasterId();
        this.setDisabled();
        this.setImageSet();
        window.updateProductVariant = this.updateProductVariant;
      }
  
      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantText();
        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
        } else {
          this.updateMedia();
          this.updateVariantInput();
          //this.renderProductInfo();
        }
        dispatchCustomEvent("product:variant-change", {
          variant: this.currentVariant,
          sectionId: this.dataset.section,
        });
      }
      updateProductVariant(event) {
        const element = event.target;
        const radioButton = document.querySelector(".varient-selection-label");
        const radioButtonSize = document.querySelector(
          ".varient-selection-size-label"
        );
  
        const productHandle = element.getAttribute("data-url");
  
        const self = this;
  
        var radioButtons = document.querySelectorAll(".varient-selection-label");
        radioButtons.forEach(function (rb) {
          rb.previousElementSibling.checked = false;
        });
  
        radioButton.checked = true;
  
        self.fetchProductSections(productHandle).then((sections) => {
          self.replaceProductSections(sections);
        });
  
        var radioSizeButtons = document.querySelectorAll(
          ".varient-selection-size-label"
        );
        radioSizeButtons.forEach(function (rb) {
          rb.checked = false;
        });
        if (radioButtonSize) {
          radioButtonSize.checked = true;
        }  
      }
  
      fetchProductSections(productHandle) {
        // console.log('fetch');
        return fetch(`${productHandle}?view=sections-template`)
          .then((response) => response.text())
          .then((html) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            const titleSection =
              tempDiv.querySelector(".product-title").innerHTML;
            const variantsSections = tempDiv.querySelectorAll(".sizes-block");
            const variantsSectionContents = Array.from(variantsSections).map(
              (section) => section.innerHTML
            );
            const variantsDataSections = tempDiv.querySelector('variant-selects script[type="application/json"]');
            const variantsDataContents = variantsDataSections.innerHTML;
            const cartFormSection =
              tempDiv.querySelector(".product-add-to-cart-form").innerHTML;
            const style = tempDiv.querySelector(".product-sku").innerHTML;
  
            var mediasection = tempDiv.querySelector(
              ".small-12.large-7.columns"
            ).innerHTML;
            if (document.querySelector("#Product-Quick-Slider")) {
              var mediasection = tempDiv.querySelector(
                ".product-image-container"
              ).innerHTML;
            }
            const pricesection = tempDiv.querySelector(
              ".product-information .product-price-container .price"
            ).innerHTML;
  
            return {
              titleSection,
              variantsSectionContents,
              variantsDataContents,
              cartFormSection,
              mediasection,
              pricesection,
              style,
            };
          })
          .catch((error) => {
            console.error("Error fetching product sections:", error);
          });
      }
  
      async replaceProductSections(sections) {
        // console.log('replace');
        const productSkuElement = document.querySelector(".product-sku");
        //if (productSkuElement && productSkuElement.innerHTML !== sections.style) {
          const variantsSections = sections.variantsSectionContents;
          document.querySelector(".product-title").innerHTML = sections.titleSection;
          const variantsContainers = document.querySelectorAll(".sizes-block");
          variantsContainers.forEach((container, index) => {
            if (variantsSections[index]) {
              container.innerHTML = variantsSections[index];
            }
          });

          const variantsDetails = document.querySelector('variant-selects script[type="application/json"]');
          variantsDetails.innerHTML = sections.variantsDataContents;
          const addTocartContainer = document.querySelector(".product-add-to-cart-form");
          addTocartContainer.innerHTML = sections.cartFormSection;
          if (document.querySelector(".small-12.large-7.columns")) {
            const mediaContainer = document.querySelector(".small-12.large-7.columns");
            mediaContainer.innerHTML = sections.mediasection;
            var mediaZoomElement = document.querySelector(".product-single__media-zoom");
            if (mediaZoomElement) {
              mediaZoomElement.style.display = "none";
            }
          } else {
            const mediaContainer = document.querySelector(
              ".product-gallery-sticky"
            );
            mediaContainer.innerHTML = sections.mediasection;
            //this.updateVariantUrl();
          }
          productSkuElement.innerHTML = sections.style;
          this.updateVariantUrl();
    
          const priceContainer = document.querySelector(
            ".product-information .product-price-container .price"
          );
          if (priceContainer) {
            priceContainer.innerHTML = sections.pricesection;
          }
          //this.bindVariantSelection();
          this.handleCookiesOnLoad();
  
            await updateVariants();
            initializeRadioButtons();
            formatSizes();
        //}
      }
  
      updateVariantUrl() {
        var checkedInput = document.querySelector(
          'fieldset.product-form__input input[type="radio"]:checked'
        );
        if (checkedInput) {
          const label = document.querySelector(`label[for="${checkedInput.id}"]`);
          var variantUrl = label.getAttribute("data-url");
          var color = label.getAttribute("data-value");
          window.history.replaceState({}, "", `${variantUrl}`);
        }
      }
      bindVariantSelection() {
        const self = this;
        const elements = document.querySelectorAll(".varient-selection-label");
        elements.forEach(function (element) {
          element.addEventListener("click", function (event) {
            self.updateProductVariant(event);
          });
        });
      }
  
      setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
      }
  
      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == " ") c = c.substring(1, c.length);
          if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
      }
  
      deleteCookie(name) {
        document.cookie = name + "=; Max-Age=-99999999; path=/";
      }
  
      handleCookiesOnLoad() {
        const self = this;
        document
          .querySelectorAll('.product-form__input:not([data-index="option1"])')
          .forEach((fieldset) => {
            let dataHandle = fieldset.getAttribute("data-handle");
            let cookieName = `selected_prod_${dataHandle}`;
            let sizeCookie = self.getCookie(cookieName);
            if (sizeCookie) {
              fieldset
                .querySelectorAll('input[type="radio"]')
                .forEach((input) => {
                  let label = input.nextElementSibling;
                  if (input.value == sizeCookie) {
                    label.click();
                    const hiddenInput = document.getElementById(
                      "selected-variant-id"
                    );
                    const hiddenInput1 = label.getAttribute("data-id");
                    const selectedVariantId = hiddenInput1;
                    hiddenInput.value = selectedVariantId;
                    const changeEvent = new Event("change");
                    hiddenInput.dispatchEvent(changeEvent);
                  }
                });
            }
          });
  
        document
          .querySelectorAll(
            '.product-form__input:not([data-index="option1"]) label'
          )
          .forEach((label) => {
            label.addEventListener("click", function () {
              setTimeout(() => {
                let fieldset = label.closest("fieldset");
                let dataHandle = fieldset.getAttribute("data-handle");
                let spanValue = label.getAttribute("data-value");
                let cookieName = `selected_prod_${dataHandle}`;
                self.deleteCookie(cookieName);
                self.setCookie(cookieName, spanValue, 1);
              }, 1000);
            });
          });
      }
      handleVariantSelectionChange() {
        const hiddenInput = document.getElementById("selected-variant-id");
        const varSizeLabels = document.querySelectorAll(
          ".varient-selection-size-label"
        );
        if (hiddenInput) {
          varSizeLabels.forEach(function (label) {
            label.addEventListener("click", function () {
              const dataId = label.getAttribute("data-id");
              const selectedVariantId = dataId;
              hiddenInput.value = selectedVariantId;
              const changeEvent = new Event("change");
              hiddenInput.dispatchEvent(changeEvent);
            });
          });
        }
      }
      handleVariantDropdownChange() {
        const hiddenInput = document.getElementById("selected-variant-id");
        if (hiddenInput) {
          var selectElement = document.getElementById("option-select-2");
          if (selectElement) {
            selectElement.addEventListener("change", function (event) {
              var selectedOption =
                event.target.options[event.target.selectedIndex];
              var dataId = selectedOption.getAttribute("data-id");
              const selectedVariantId = dataId;
              hiddenInput.value = selectedVariantId;
              const changeEvent = new Event("change");
              hiddenInput.dispatchEvent(changeEvent);
              const skuElement = document.querySelector(".product-sku span.sku-value");
              if (skuElement && selectedOption.getAttribute("data-sku")) {
                  skuElement.innerHTML = selectedOption.getAttribute("data-sku");
              }
            });
          }
        }
      }
      updateOptions() {
        this.fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = [];
        this.fieldsets.forEach((fieldset, i) => {
          if (fieldset.querySelector("select")) {
            this.options.push(fieldset.querySelector("select").value);
          } else if (fieldset.querySelectorAll("input").length) {
            this.options.push(fieldset.querySelector("input:checked").value);
          }
        });
      }
      updateVariantText() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        fieldsets.forEach((item, i) => {
          let labelValueSpan = item.querySelector(".form__label__value");
          if (labelValueSpan) {
            if (
              item.dataset.index === "option1" &&
              item.dataset.handle === "color"
            ) {
              const selectedInput = item.querySelector(
                'input[type="radio"]:checked'
              );
  
              if (selectedInput) {
                const selectedLabel = item.querySelector(
                  `label[for="${selectedInput.id}"]`
                );
                if (selectedLabel) {
                  const colorValue =
                    selectedLabel.getAttribute("title") ||
                    selectedLabel.getAttribute("data-value");
                  labelValueSpan.innerHTML = colorValue;
                }
              }
            } else {
              if (this.options[i] !== undefined) {
                labelValueSpan.innerHTML = this.options[i];
              }
            }
          }
        });
      }
      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }
  
      updateMedia() {
        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
  
        let productSlider = this.closest(".thb-product-detail").querySelector(
            ".product-images"
          ),
          thumbnails = this.closest(".thb-product-detail").querySelector(
            "#Product-Thumbnails"
          );
  
        this.setActiveMedia(
          `#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`,
          productSlider,
          thumbnails
        );
      }
      setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
        let flkty = Flickity.data(productSlider),
          activeMedia = productSlider.querySelector(mediaId);
  
        if (flkty && this.hideVariants) {
          if (
            productSlider.querySelector(
              ".product-images__slide.is-initial-selected"
            )
          ) {
            productSlider
              .querySelector(".product-images__slide.is-initial-selected")
              .classList.remove("is-initial-selected");
          }
          [].forEach.call(
            productSlider.querySelectorAll(
              ".product-images__slide-item--variant"
            ),
            function (el) {
              el.classList.remove("is-active");
            }
          );
  
          activeMedia.classList.add("is-active");
          activeMedia.classList.add("is-initial-selected");
  
          this.setImageSetMedia();
  
          if (thumbnails) {
            let activeThumb = thumbnails.querySelector(thumbId);
  
            if (
              thumbnails.querySelector(".product-thumbnail.is-initial-selected")
            ) {
              thumbnails
                .querySelector(".product-thumbnail.is-initial-selected")
                .classList.remove("is-initial-selected");
            }
            [].forEach.call(
              thumbnails.querySelectorAll(".product-images__slide-item--variant"),
              function (el) {
                el.classList.remove("is-active");
              }
            );
  
            activeThumb.classList.add("is-active");
            activeThumb.classList.add("is-initial-selected");
          }
  
          productSlider.reInit(this.imageSetIndex);
          productSlider.selectCell(mediaId);
        } else if (flkty) {
          productSlider.selectCell(mediaId);
        }
      }
  
      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        var titleWithHyphens = this.currentVariant.title.replace(/ /g, "-");
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}/${titleWithHyphens
            .toLowerCase()
            .replace("/", "-")
            .trim()
            .replace(" ", "-")}`
        );
      }
  
      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`
        );
        if (!shareButton) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
        );
      }
  
      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(
            new Event("change", {
              bubbles: true,
            })
          );
        });
      }
  
      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          ".pickup-availability-wrapper"
        );
  
        if (!pickUpAvailability) return;
  
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }
  
      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;
  
        const productForm = section.querySelector("product-form");
        if (productForm) productForm.handleErrorMessage();
      }
  
      getSectionsToRender() {
        return [
          `price-${this.dataset.section}`,
          `inventory-${this.dataset.section}`,
          `sku-${this.dataset.section}`,
        ];
      }
  
      renderProductInfo() {
        let sections = this.getSectionsToRender();
        fetch(
          `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            sections.forEach((id) => {
              const destination = document.getElementById(id);
              const source = html.getElementById(id);
  
              //if (source && destination) destination.innerHTML = source.innerHTML;
  
              //const price = document.getElementById(id);
  
              //if (price) price.classList.remove("visibility-hidden");
            });
            this.toggleAddButton(
              !this.currentVariant.available,
              window.theme.variantStrings.soldOut
            );
          });
      }
  
      toggleAddButton(disable = true, text = false, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        if (!productForm) return;
  
        const productTemplate = productForm
          .closest(".product-form")
          .getAttribute("template");
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
  
        if (!addButton) return;
  
        if (disable) {
          //addButton.setAttribute('disabled', 'disabled');
          //if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButton.classList.remove("loading");
          addButtonText.textContent = window.theme.variantStrings.addToCart;
  
          if (productTemplate?.includes("pre-order")) {
            addButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            addButtonText.textContent = window.theme.variantStrings.addToCart;
          }
        }
        if (!modifyClass) return;
      }
  
      setUnavailable() {
        const button = document.getElementById(
          `product-form-${this.dataset.section}`
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (!addButton) return;
        addButtonText.textContent = window.theme.variantStrings.unavailable;
        addButton.classList.add("sold-out");
        if (price) price.classList.add("visibility-hidden");
      }
  
      setDisabled() {
        if (this.isDisabledFeature != 'true') {
          return;
        }
        const variant_data = this.getVariantData();
        if (variant_data) {
          let selected_options = false;
          if (this.currentVariant) {
            selected_options = this.currentVariant.options.map((value, index) => {
              return {
                value,
                index: `option${index + 1}`
              };
            });
          } else {
            let found_option = variant_data.find(option => {
              return option.option1 === this.options[0];
            });
            if (found_option) {
              selected_options = [
                {
                  "value": this.options[0],
                  "index": "option1"
                },
                {
                  "value": found_option.option2,
                  "index": "option2"
                }
              ];
            } else {
              return;
            }
          }
          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);
          this.fieldsets.forEach((fieldset, i) => {
            const fieldset_options = Object.values(available_options)[i];
            if (fieldset_options) {
              if (fieldset.querySelector('select')) {
                fieldset_options.forEach((option, option_i) => {
                  const optionElement = fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']');
                  if (optionElement) {
                    optionElement.disabled = option.isUnavailable;
                  }
                });
              } else if (fieldset.querySelectorAll('input').length) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  if (fieldset_options[input_i]) {
                    input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                  }
                });
              }
            }
          });
        }
        return true;
      }
  
  
      getImageSetName(variant_name) {
        return variant_name
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      }
  
      setImageSet() {
        if (!this.productSlider) return;
  
        let dataSetEl = this.productSlider.querySelector("[data-set-name]");
        if (dataSetEl) {
          this.imageSetName = dataSetEl.dataset.setName;
          this.imageSetIndex = this.querySelector(
            '.product-form__input[data-handle="' + this.imageSetName + '"]'
          ).dataset.index;
          this.dataset.imageSetIndex = this.imageSetIndex;
          this.setImageSetMedia();
        }
      }
      setImageSetMedia() {
        if (!this.imageSetIndex) {
          return;
        }
  
        let setValue = this.getImageSetName(
          this.currentVariant[this.imageSetIndex]
        );
        let group = this.imageSetName + "_" + setValue;
        let selected_set_images = this.productWrapper.querySelectorAll(
            `.product-images__slide[data-set-name="${this.imageSetName}"]`
          ),
          selected_set_thumbs = this.productWrapper.querySelectorAll(
            `.product-thumbnail[data-set-name="${this.imageSetName}"]`
          );
  
        if (this.hideVariants) {
          // Product images
          this.productWrapper
            .querySelectorAll(".product-images__slide")
            .forEach((thumb) => {
              if (thumb.dataset.group && thumb.dataset.group !== group) {
                thumb.classList.remove("is-active");
              }
            });
          selected_set_images.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
  
          // Product thumbnails
          this.productWrapper
            .querySelectorAll(".product-thumbnail")
            .forEach((thumb) => {
              if (thumb.dataset.group && thumb.dataset.group !== group) {
                thumb.classList.remove("is-active");
              }
            });
          selected_set_thumbs.forEach((thumb) => {
            thumb.classList.toggle("is-active", thumb.dataset.group === group);
          });
        }
      }
  
      createAvailableOptionsTree(variant_data, selected_options) {
        // Reduce variant array into option availability tree
        return variant_data.reduce(
          (options, variant) => {
            // Check each option group (e.g. option1, option2, option3) of the variant
            Object.keys(options).forEach((index) => {
              if (variant[index] === null) return;
  
              let entry = options[index].find(
                (option) => option.value === variant[index]
              );
  
              if (typeof entry === "undefined") {
                // If option has yet to be added to the options tree, add it
                entry = {
                  value: variant[index],
                  isUnavailable: true,
                };
                options[index].push(entry);
              }
  
              // Check how many selected option values match a variant
              const countVariantOptionsThatMatchCurrent = selected_options.reduce(
                (count, { value, index }) => {
                  return variant[index] === value ? count + 1 : count;
                },
                0
              );
  
              // Only enable an option if an available variant matches all but one current selected value
              if (
                countVariantOptionsThatMatchCurrent >=
                selected_options.length - 1
              ) {
                entry.isUnavailable =
                  entry.isUnavailable && variant.available
                    ? false
                    : entry.isUnavailable;
              }
  
              // Make sure if a variant is unavailable, disable currently selected option
              if (
                (!this.currentVariant || !this.currentVariant.available) &&
                selected_options.find(
                  (option) =>
                    option.value === entry.value && index === option.index
                )
              ) {
                entry.isUnavailable = true;
              }
  
              // First option is always enabled
              if (index === "option1") {
                entry.isUnavailable =
                  entry.isUnavailable && variant.available
                    ? false
                    : entry.isUnavailable;
              }
            });
  
            return options;
          },
          {
            option1: [],
            option2: [],
            option3: [],
          }
        );
      }
  
      getVariantData() {
        this.variantData =
          JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      mainProductFetch(){
          document.addEventListener("DOMContentLoaded", async function () {
            const shopUrl = Shopify.shop;
            let productVariants = [];
            const color_settings = window[`settings`];
            const customColorsArray = color_settings.color_swatches.split(',').map(color => {
                const [key, value] = color.split(':').map(part => part.trim());
                return { key: key.toLowerCase(), value: value };
            });
            const keyArray = customColorsArray.map((color) => color.key);
            const valArray = customColorsArray.map((color) => color.value);
            
            const initializeCustomSwatches = async () => {
        
                const fetchProductDetails = async (tag) => {
                    const storefrontAccessToken = 'e37d6f5fced72df1026762e8fcf43b21';
                    const url = `https://${shopUrl}/api/2024-10/graphql.json`;
        
                    const productQuery = `
                        query Products($query: String!, $country: CountryCode) @inContext(country: $country) {
                            products(first: 250, query: $query) {
                                edges {
                                    node {
                                        id
                                        title
                                        handle
                                        discontinued: metafield(namespace: "custom", key: "discontinued") {
                                            value
                                            type
                                        }
                                        variantSwatchColor: metafield(namespace: "custom", key: "variant_swatch_color") {
                                            value
                                            type
                                        }
                                        totalInventory
                                        priceRange {
                                            maxVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                            minVariantPrice {
                                                amount
                                                currencyCode
                                            }
                                        }
                                        images(first: 2) {
                                            edges {
                                                node {
                                                    src
                                                    altText
                                                }
                                            }
                                        }
                                        variants(first: 100) {
                                            edges {
                                                node {
                                                    id
                                                    title
                                                    quantityAvailable
                                                    compareAtPrice {
                                                        amount
                                                        currencyCode
                                                    }
                                                    selectedOptions {
                                                        name
                                                        value
                                                    }
                                                    image {
                                                        src
                                                        altText
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    `;
                
                    try {
                        const response = await fetch(url, {
                            method: "POST",
                            headers: {
                                'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                query: productQuery,
                                variables: {
                                    query: `tag:${tag}`,
                                    country: Shopify.country
                                }
                            })
                        });
                
                        const { data, errors } = await response.json();
                
                        if (errors) {
                            console.error('GraphQL Errors:', errors);
                            return null;
                        }
                
                        if (data && data.products.edges) {
                            const productDetails = data.products.edges
                              .map(({ node }) => {
                                  if (node) {
                                      return node;
                                  } else {
                                      console.warn("Encountered a null product.");
                                      return null;
                                  }
                              })
                              .filter(Boolean);
                
                            return productDetails;
                        } else {
                            console.warn("No product data found.");
                            return null;
                        }
                    } catch (error) {
                        console.error("Error fetching product:", error);
                        return []; // Return an empty array on error to prevent breaking subsequent code
                    }
                };
        
                async function extractVariantData(variants) {
                    const formattedVariants = variants.edges.map(edge => {
                        const variant = JSON.parse(JSON.stringify(edge.node));
                        variant.id = variant.id.split("/").pop();
                        return variant;
                    });
        
                    formattedVariants.forEach(variant => {
                        if (!productVariants.some(existingVariant => existingVariant.id === variant.id)) {
                            productVariants.push(variant);
                        }
                    });
        
                    const colors = new Set();
                    formattedVariants.forEach(variant => {
                        const colorOption = variant.selectedOptions.find(option => option.name === 'Color');
                        if (colorOption) {
                            colors.add(colorOption.value);
                        }
                    });
        
                    return [...colors]; // Return as an array
                }
        
                const handleCustomSwatches = async () => {
                    const productCards = document.querySelectorAll(".product-swatch");
                    //const variantSelectsInstance = new window.VariantSelects();
                    productCards.forEach(async card => {
                        const prodOldSwatches = card.querySelector('.product-swatches');
                        const productId = card.getAttribute('data-product-id');
                        const productStyleNo = card.getAttribute('data-product-no');
                        const productDetails = await fetchProductDetails(productStyleNo);
                        const colorFieldset = document.querySelector('fieldset.product-form__input[data-handle="color"]');
                        let inputHTML = '';
                        for (const productDetail of productDetails) {
                            const productAvailable = productDetail.totalInventory > 0;
                            const productUID = productDetail.id;
                            const prodID = productUID.split("/").pop();
                            const prodHandle = productDetail.handle;
                            const prodUrl = `/products/`; // Corrected URL path
                            const ColorVariants = await extractVariantData(productDetail.variants);
                        
                            if(productAvailable){
                              ColorVariants.forEach(color => {
                                  let colorValue = color;
                                  const swatchOptionAvailable = productAvailable;
          
                                  // Generate first_option and other dynamic variables
                                  const first_option = color.toLowerCase().trim();
                                  const first_option_title_val = color;
                                  colorValue = first_option.toLowerCase().trim();
                                  const customColorIndex = keyArray.indexOf(colorValue);
                                  if (customColorIndex > -1) {
                                      colorValue = valArray[customColorIndex];
                                  }
                                  let bgValue = false;
                                  const swatchColor = productDetail.variantSwatchColor?.value;
                                  if (swatchColor) {
                                      const swatchParts = swatchColor.split('-');
                                      const lastPart = swatchParts[swatchParts.length - 1].trim();
                                      if (lastPart.includes('#')) {
                                          colorValue = lastPart;
                                      } else {
                                          bgValue = lastPart;
                                          colorValue = "var(--bg-body)";
                                      }
                                  } else {
                                      if (colorValue.includes(".")) {
                                          bgValue = colorValue;
                                          colorValue = "var(--bg-body)";
                                      }
                                  }
                                  const bgImageUrl = bgValue ? `--option-color-image: url('//${shopUrl}/cdn/shop/files/${bgValue}');` : "";
                                  const isChecked = productId === prodID ? "checked" : "";
                                  
                                  // Create radio input and label for swatch
                                  inputHTML += `
                                      <input
                                          type="radio"
                                          id="${prodID}-${first_option}"
                                          name="${productDetail.title}"
                                          value="${first_option_title_val}"
                                          form="form-${prodID}-${first_option}"
                                          ${!swatchOptionAvailable ? 'disabled' : ''}
                                          ${isChecked}
                                      >
                                      <label for="${prodID}-${first_option}" title="${first_option_title_val}" 
                                          id="${prodID}-${first_option}-label"
                                          class="${swatchOptionAvailable ? 'true' : 'false'} varient-selection-label${!swatchOptionAvailable ? ' disabled' : ''}" 
                                          style="--option-color: ${colorValue}; ${bgImageUrl}" 
                                          data-url="${prodUrl}${prodHandle}" data-value="${first_option}">
                                          ${first_option}
                                      </label>
                                  `;
                              });
                            }
                        }
                        if (inputHTML) {
                          const initialVariants = colorFieldset.querySelectorAll('input, label');
                          initialVariants?.forEach(variant => {
                            variant.remove();
                          });
                          colorFieldset.innerHTML += inputHTML;
                        }
                    });
                };
        
                await handleCustomSwatches();
            };  
            await initializeCustomSwatches();
        });
      }
    }
    customElements.define("variant-selects", VariantSelects);
  
    /**
     *  @class
     *  @function VariantRadios
     */
    class VariantRadios extends VariantSelects {
      constructor() {
        super();
      }
  
      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll("fieldset"));
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked
          ).value;
        });
      }
      updateVariantText() {}
    }
  
    customElements.define("variant-radios", VariantRadios);
  }
  
  if (!customElements.get("product-slider")) {
    /**
     *  @class
     *  @function ProductSlider
     */
    class ProductSlider extends HTMLElement {
      constructor() {
        super();
  
        this.addEventListener("change", this.setupProductGallery);
      }
      connectedCallback() {
        this.product_container = this.closest(".thb-product-detail");
        this.thumbnail_container = this.product_container.querySelector(
          ".product-thumbnail-container"
        );
        this.video_containers = this.querySelectorAll(
          ".product-single__media-external-video--play"
        );
  
        this.setOptions();
        // Start Slider
        this.init();
      }
      setOptions() {
        this.hide_variants = this.dataset.hideVariants == "true";
        if (this.thumbnail_container) {
          this.thumbnails =
            this.thumbnail_container.querySelectorAll(".product-thumbnail");
        }
        this.prev_button = this.querySelector(".flickity-prev");
        this.next_button = this.querySelector(".flickity-next");
        this.options = {
          wrapAround: true,
          pageDots: true,
          contain: true,
          adaptiveHeight: true,
          initialIndex: ".is-initial-selected",
          prevNextButtons: false,
          fade: false,
          cellSelector: ".product-images__slide.is-active",
        };
  
        if (this.classList.contains("product-quick-images")) {
          this.options.cellAlign = "left";
          this.options.pageDots = false;
          this.options.freeScroll = true;
          this.options.wrapAround = false;
        }
      }
      init() {
        this.flkty = new Flickity(this, this.options);
  
        this.selectedIndex = this.flkty.selectedIndex;
  
        // Setup Events
        this.setupEvents();
  
        // Start Gallery
        this.setupProductGallery();
      }
      reInit() {
        this.flkty.destroy();
  
        this.setOptions();
  
        this.flkty = new Flickity(this, this.options);
  
        // Setup Events
        this.setupEvents();
  
        this.selectedIndex = this.flkty.selectedIndex;
      }
      setupEvents() {
        const _this = this;
        if (this.prev_button) {
          let prev = this.prev_button.cloneNode(true);
          this.prev_button.parentNode.append(prev);
          this.prev_button.remove();
          prev.addEventListener("click", (event) => {
            this.flkty.previous();
          });
          prev.addEventListener("keyup", (event) => {
            this.flkty.previous();
            event.preventDefault();
          });
        }
        if (this.next_button) {
          let next = this.next_button.cloneNode(true);
          this.next_button.parentNode.append(next);
          this.next_button.remove();
          next.addEventListener("click", (event) => {
            this.flkty.next();
          });
          next.addEventListener("keyup", (event) => {
            this.flkty.next();
            event.preventDefault();
          });
        }
        this.flkty.on("settle", function (index) {
          _this.selectedIndex = index;
        });
        this.flkty.on("change", (index) => {
          let previous_slide = this.flkty.cells[_this.selectedIndex].element,
            previous_media = previous_slide.querySelector(
              ".product-single__media"
            ),
            slide = this.flkty.cells[index].element,
            media = slide.querySelector(".product-single__media"),
            active_thumb = false;
  
          if (this.thumbnail_container) {
            let active_thumbs = Array.from(this.thumbnails).filter((element) =>
                element.classList.contains("is-active")
              ),
              active_thumb = active_thumbs[index]
                ? active_thumbs[index]
                : active_thumbs[0];
  
            this.thumbnails.forEach((item, i) => {
              item.classList.remove("is-initial-selected");
            });
            active_thumb.classList.add("is-initial-selected");
          }
  
          requestAnimationFrame(() => {
            if (active_thumb) {
              if (active_thumb.offsetParent === null) {
                return;
              }
              const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
                windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
              active_thumb.parentElement.scrollTo({
                left:
                  active_thumb.offsetLeft -
                  windowHalfWidth +
                  active_thumb.clientWidth / 2,
                top:
                  active_thumb.offsetTop -
                  windowHalfHeight +
                  active_thumb.clientHeight / 2,
                behavior: "smooth",
              });
            }
          });
  
          // Stop previous video
          if (
            previous_media.classList.contains(
              "product-single__media-external-video"
            )
          ) {
            if (previous_media.dataset.provider === "youtube") {
              previous_media.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({
                  event: "command",
                  func: "pauseVideo",
                  args: "",
                }),
                "*"
              );
            } else if (previous_media.dataset.provider === "vimeo") {
              previous_media.querySelector("iframe").contentWindow.postMessage(
                JSON.stringify({
                  method: "pause",
                }),
                "*"
              );
            }
          } else if (
            previous_media.classList.contains(
              "product-single__media-native-video"
            )
          ) {
            previous_media.querySelector("video").pause();
          }
  
          // Draggable.
          if (media.classList.contains("product-single__media-model")) {
            this.setDraggable(false);
          } else {
            this.setDraggable(true);
          }
        });
  
        if (this.thumbnail_container) {
          setTimeout(() => {
            let active_thumbs = Array.from(this.thumbnails).filter(
              (element) => element.clientWidth > 0
            );
            active_thumbs.forEach((thumbnail, index) => {
              thumbnail.addEventListener("click", () => {
                this.thumbnailClick(thumbnail, index);
              });
            });
          });
        }
        let scrollbar = document.querySelector(
          ".product-quick-images__scrollbar>div"
        );
  
        if (scrollbar) {
          this.flkty.on("scroll", function (progress) {
            progress = Math.max(0, Math.min(1, progress));
            scrollbar.style.transform = "scaleX(" + progress + ")";
          });
        }
      }
      thumbnailClick(thumbnail, index) {
        [].forEach.call(this.thumbnails, function (el) {
          el.classList.remove("is-initial-selected");
        });
        thumbnail.classList.add("is-initial-selected");
        this.flkty.select(index);
      }
      setDraggable(draggable) {
        this.flkty.options.draggable = draggable;
        this.flkty.updateDraggable();
      }
      selectCell(mediaId) {
        this.flkty.selectCell(mediaId);
      }
      setupProductGallery() {
        if (!this.querySelectorAll(".product-single__media-zoom").length) {
          return;
        }
        this.setEventListeners();
      }
      buildItems() {
        this.activeImages = Array.from(
          this.querySelectorAll(
            ".product-images__slide.is-active .product-single__media-image"
          )
        );
  
        return this.activeImages.map((item) => {
          let index = [].indexOf.call(
            item.parentNode.parentNode.children,
            item.parentNode
          );
  
          let activelink = item.querySelector(".product-single__media-zoom");
  
          activelink.dataset.index = index;
          return {
            src: activelink.getAttribute("href"),
            msrc: activelink.dataset.msrc,
            w: activelink.dataset.w,
            h: activelink.dataset.h,
          };
        });
      }
      setEventListeners() {
        this.links = this.querySelectorAll(".product-single__media-zoom");
        this.pswpElement = document.querySelectorAll(".pswp")[0];
        this.pswpOptions = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: false,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: false,
          arrowEl: true,
          preloaderEl: true,
          getThumbBoundsFn: () => {
            const thumbnail = this.querySelector(
                ".product-images__slide.is-selected"
              ),
              pageYScroll =
                window.pageYOffset || document.documentElement.scrollTop,
              rect = thumbnail.getBoundingClientRect();
            return {
              x: rect.left,
              y: rect.top + pageYScroll,
              w: rect.width,
            };
          },
        };
  
        this.links.forEach((link) => {
          link.addEventListener("click", (e) => this.zoomClick(e, link));
        });
      }
      zoomClick(e, link) {
        this.items = this.buildItems();
        this.pswpOptions.index = parseInt(link.dataset.index, 10);
        if (typeof PhotoSwipe !== "undefined") {
          let pswp = new PhotoSwipe(
            this.pswpElement,
            PhotoSwipeUI_Default,
            this.items,
            this.pswpOptions
          );
          pswp.listen("firstUpdate", function () {
            pswp.listen("parseVerticalMargin", function (item) {
              item.vGap = {
                top: 50,
                bottom: 50,
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      }
    }
    customElements.define("product-slider", ProductSlider);
  }
  
  /**
   *  @class
   *  @function ProductForm
   */
  if (!customElements.get("product-form")) {
    customElements.define(
      "product-form",
      class ProductForm extends HTMLElement {
        constructor() {
          super();
  
          this.form = this.querySelector("form");
          this.form.querySelector("[name=id]").disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cartNotification = document.querySelector("cart-notification");
          this.body = document.body;
  
          this.hideErrors = this.dataset.hideErrors === "true";
        }
  
        onSubmitHandler(evt) {
          evt.preventDefault();
          if (!this.form.reportValidity()) {
            return;
          }
          const submitButton = this.querySelector('[type="submit"]');
          if (submitButton.classList.contains("loading")) return;
  
          this.handleErrorMessage();
  
          submitButton.setAttribute("aria-disabled", true);
          submitButton.classList.add("loading");
  
          const config = {
            method: "POST",
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              Accept: "application/javascript",
            },
          };
          const formData = new FormData(this.form);
          formData.append(
            "sections",
            this.getSectionsToRender().map((section) => section.section)
          );
          formData.append("sections_url", window.location.pathname);
          config.body = formData;
  
          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                dispatchCustomEvent("product:variant-error", {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                return;
              }
  
              this.renderContents(response);
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("aria-disabled");
            });
        }
  
        getSectionsToRender() {
          return [
            {
              id: "Cart",
              section: "main-cart",
              selector: ".thb-cart-form",
            },
            {
              id: "Cart-Drawer",
              section: "cart-drawer",
              selector: ".cart-drawer",
            },
            {
              id: "cart-drawer-toggle",
              section: "cart-bubble",
              selector: ".thb-item-count",
            },
          ];
        }
        renderContents(parsedState) {
          this.getSectionsToRender().forEach((section) => {
            if (!document.getElementById(section.id)) {
              return;
            }
            const elementToReplace =
              document
                .getElementById(section.id)
                .querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
            if (typeof CartDrawer !== "undefined") {
              new CartDrawer();
            }
            if (typeof Cart !== "undefined") {
              new Cart().renderContents(parsedState);
            }
          });
  
          if (document.getElementById("Cart-Drawer")) {
            this.body.classList.add("open-cc");
            document.getElementById("Cart-Drawer").classList.add("active");
  
            dispatchCustomEvent("cart-drawer:open");
          }
  
          let product_drawer = document.getElementById("Product-Drawer");
          if (product_drawer && product_drawer.contains(this)) {
            product_drawer.classList.remove("active");
  
            if (!document.getElementById("Cart-Drawer")) {
              this.body.classList.remove("open-cc");
            }
          }
        }
        getSectionInnerHTML(html, selector = ".shopify-section") {
          return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
        }
        handleErrorMessage(errorMessage = false) {
          if (this.hideErrors) return;
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );
  
          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);
  
          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  
    /*const fieldsets = document.querySelectorAll(
      ".variations .product-form__input--color"
    );
    fieldsets.forEach((fieldset) => {
      const firstLabel = fieldset.querySelector("label");
      if (firstLabel) {
        // firstLabel.click();
      }
    });*/
  }

async function updateVariants() {
    const scriptTag = document.querySelector('variant-selects script[type="application/json"]');
    const container = document.querySelector('variant-selects .variations');

    let availableVariants = [];
    let unavailableVariants = [];

    if (scriptTag) {
        const jsonString = scriptTag.textContent.trim();
        try {
            const jsonObject = JSON.parse(jsonString);
            if (Array.isArray(jsonObject)) {
                availableVariants = jsonObject.filter(variant => variant.available === true);
                unavailableVariants = jsonObject.filter(variant => variant.available === false);
            } else {
                console.warn('JSON is not an array');
            }
        } catch (error) {
            console.warn('Error parsing JSON:', error);
        }
    }

    if (container) {
        const fieldsets = container.querySelectorAll('fieldset.product-form__input');
        if (fieldsets.length > 0) {
            const firstFieldset = fieldsets[0];
            const checkedRadio = firstFieldset.querySelector('input[type="radio"]:checked');
            if (checkedRadio) {
                const checkedValue = checkedRadio.value;
                const filteredAvailableVariants = availableVariants.filter(variant => variant.option1 === checkedValue);
                const firstAvailableVariant = filteredAvailableVariants[0];
                if (firstAvailableVariant) {
                    const { option2, option3, id, sku } = firstAvailableVariant;
                    const sameOption2Variants = availableVariants.filter(variant => variant.option2 === option2);
                    const sameOption3Variants = availableVariants.filter(variant => variant.option3 === option3);


                    if (fieldsets.length > 1) {
                        const secondFieldset = fieldsets[1];
                        const radiosInSecondFieldset = secondFieldset.querySelectorAll('input[type="radio"]');
                        const secondSelectedValue = secondFieldset.querySelector('legend.form__label span.form__label__value');
                        if (secondSelectedValue) {
                            radiosInSecondFieldset.forEach(radio => {
                                radio.checked = false;
                                radio.classList.remove('is_selected', 'is-disabled');
                            });
                            radiosInSecondFieldset.forEach(radio => {
                                if (radio.value === option2) {
                                    radio.classList.add('is_selected');
                                    radio.classList.remove('is-disabled');
                                    radio.checked = true;
                                    secondSelectedValue.textContent = radio.value;
                                } else if (!sameOption3Variants.some(variant => variant.option2 === radio.value)) {
                                    radio.classList.add('is-disabled');
                                    radio.classList.remove('is_selected');
                                    radio.checked = false;
                                }
                            });
                        } else {
                            console.warn('Second fieldset does not contain the expected span element');
                        }
                    }

                    if (fieldsets.length > 2) {
                        const thirdFieldset = fieldsets[2];
                        const radiosInThirdFieldset = thirdFieldset.querySelectorAll('input[type="radio"]');
                        const thirdSelectedValue = thirdFieldset.querySelector('legend.form__label span.form__label__value');
                        if (thirdSelectedValue) {
                            radiosInThirdFieldset.forEach(radio => {
                                radio.checked = false;
                                radio.classList.remove('is_selected', 'is-disabled');
                            });
                            radiosInThirdFieldset.forEach(radio => {
                                if (radio.value === option3) {
                                    radio.classList.add('is_selected');
                                    radio.classList.remove('is-disabled');
                                    radio.checked = true;
                                    thirdSelectedValue.textContent = radio.value;
                                } else if (!sameOption2Variants.some(variant => variant.option3 === radio.value)) {
                                    radio.classList.add('is-disabled');
                                    radio.classList.remove('is_selected');
                                    radio.checked = false;
                                }
                            });
                        } else {
                            console.warn('Third fieldset does not contain the expected span element');
                        }
                    }

                    const selectedVariant = document.getElementById('selected-variant-id');
                    selectedVariant.value = id;
                    const selectedSku = document.querySelector('.thb-product-detail .product-information--inner .product-sku span.sku-value');
                    selectedSku.innerHTML = sku;
                }
            }
        }
    }
}

function initializeRadioButtons() {
  const radioButtons = document.querySelectorAll('variant-selects .variations fieldset.product-form__input:not([data-handle="color"]) input[type="radio"]');
  
  radioButtons.forEach(radio => {
    radio.addEventListener('change', handleRadioChange);
  });
}

function handleRadioChange(event) {
    const selectedRadio = event.target;
    const selectedValue = selectedRadio.value;
    const fieldset = selectedRadio.closest('fieldset.product-form__input');
    const fieldsets = document.querySelectorAll('variant-selects .variations fieldset.product-form__input');
    const fieldsetIndex = Array.from(fieldsets).indexOf(fieldset) + 1;
    const secondFieldset = fieldsets[1];
    const thirdFieldset = fieldsets[2];

    const scriptTag = document.querySelector('variant-selects script[type="application/json"]');
    
    if (!scriptTag) {
        console.error('Script tag not found');
        return;
    }
    
    let availableVariants = [];

    try {
        const jsonObject = JSON.parse(scriptTag.textContent.trim());
        if (Array.isArray(jsonObject)) {
            availableVariants = jsonObject.filter(variant => variant.available);
            unavailableVariants = jsonObject.filter(variant => !variant.available);
        } else {
            console.error('JSON is not an array');
            return;
        }
    } catch (error) {
        console.error('Error parsing JSON:', error);
        return;
    }
    
    let filteredAvailableVariants = [];
    // let selectedVariant = {};
    // let option1 = '', option2 = '', option3 = '';
    // const selectedFieldsets = container.querySelectorAll('fieldset.product-form__input');

    // selectedFieldsets.forEach((fieldset, index) => {
    //     const radios = fieldset.querySelectorAll('input[type="radio"]');
    //     radios.forEach(radio => {
    //         if (radio.checked) {
    //             if (index === 0) {
    //                 option1 = radio.value;
    //             } else if (index === 1) {
    //                 option2 = radio.value;
    //             } else if (index === 2) {
    //                 option3 = radio.value;
    //             }
    //         }
    //     });
    // });

    // if (option1 && option2 && option3) {
    //     selectedVariant = availableVariants.find(variant => variant.option1 === option1 && variant.option2 === option2 && variant.option3 === option3 );

    //     if (selectedVariant) {
    //         const { id, sku } = selectedVariant;

    //         if (sku) {
    //             const selectedSku = document.querySelector('.thb-product-detail .product-information--inner .product-sku span.sku-value');
    //             if (selectedSku) {
    //                 selectedSku.innerHTML = sku;
    //             }
    //             const selectedVariant = document.getElementById('selected-variant-id');
    //             if(selectedVariant){
    //               selectedVariant.value = id;
    //             }
    //         }
    //     }
    // }

    if (fieldsetIndex === 2 && secondFieldset) {
        filteredAvailableVariants = availableVariants.filter(variant => variant.option2 === selectedValue);
        updateFieldsetRadios(thirdFieldset, filteredAvailableVariants, 'option3');
    } else if (fieldsetIndex === 3 && thirdFieldset) {
        filteredAvailableVariants = availableVariants.filter(variant => variant.option3 === selectedValue);
        updateFieldsetRadios(secondFieldset, filteredAvailableVariants, 'option2');
    }
}

function updateFieldsetRadios(fieldset, filteredAvailableVariants, optionKey) {
    const radiosInFieldset = fieldset.querySelectorAll('input[type="radio"]');
    
    radiosInFieldset.forEach(radio => {
        if (filteredAvailableVariants.some(variant => variant[optionKey] === radio.value)) {
            radio.classList.remove('is-disabled');
        } else {
            radio.classList.remove('is_selected');
            radio.classList.add('is-disabled');
            radio.checked = false;
        }
    });
}
async function formatSizes() {
    const sizes = ["XXS", "XS", "XS/S", "S", "S/M", "M", "M/L", "L", "L/XL", "XL", "XXL", "1X", "2X", "3X", "4XL", "O/S"];
    const bands = ["26", "28", "30", "32", "34", "36", "38"];
    const cups = ["A", "B", "C", "D", "DD", "DDD", "E"];
    
    const fieldsetSize = document.querySelector('fieldset.product-form__input[data-handle="size"]');
    const fieldsetBand = document.querySelector('fieldset.product-form__input[data-handle="band"]');
    const fieldsetCup = document.querySelector('fieldset.product-form__input[data-handle="cup"]');
    
    function sortInputLabelPairs(pairs, orderArray = null, defaultSort = 'alphabetical') {
        pairs.sort((a, b) => {
            const aValue = a.input.value.toUpperCase();
            const bValue = b.input.value.toUpperCase();
            
            if (orderArray) {
                const aIndex = orderArray.indexOf(aValue);
                const bIndex = orderArray.indexOf(bValue);

                if (aIndex !== -1 && bIndex !== -1) {
                    return aIndex - bIndex;
                } else if (aIndex !== -1) {
                    return -1;
                } else if (bIndex !== -1) {
                    return 1;
                }
            }
            
            const aNumeric = parseFloat(aValue);
            const bNumeric = parseFloat(bValue);
            if (!isNaN(aNumeric) && !isNaN(bNumeric)) {
                return aNumeric - bNumeric;
            }

            return defaultSort === 'alphabetical' ? aValue.localeCompare(bValue) : 0;
        });
    }

    function formatFieldset(fieldset, orderArray = null, defaultSort = 'alphabetical') {
        if (fieldset) {
            const legend = fieldset.querySelector("legend.form__label");

            const inputLabelPairs = Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => {
                const label = fieldset.querySelector(`label[for="${input.id}"]`);
                return { input, label };
            });

            sortInputLabelPairs(inputLabelPairs, orderArray, defaultSort);

            inputLabelPairs.forEach((pair) => {
                pair.input.remove();
                pair.label.remove();
            });

            for (let i = inputLabelPairs.length - 1; i >= 0; i--) {
                legend.insertAdjacentElement("afterend", inputLabelPairs[i].label);
                inputLabelPairs[i].label.insertAdjacentElement("beforebegin", inputLabelPairs[i].input);
            }
        }
    }

    if (fieldsetSize) {
        formatFieldset(fieldsetSize, sizes);
    } else if (fieldsetBand) {
        formatFieldset(fieldsetBand, bands, 'numeric');
    } else if (fieldsetCup) {
        formatFieldset(fieldsetCup, cups, 'alphabetical');
    } else {
        const genericFieldset = document.querySelector('fieldset.product-form__input'); // Generic fallback
        if (genericFieldset) {
            const hasNumericValues = Array.from(genericFieldset.querySelectorAll('input[type="radio"]'))
                .some(input => !isNaN(parseFloat(input.value)));
        
            formatFieldset(genericFieldset, null, hasNumericValues ? 'numeric' : 'alphabetical');
        }
    }
}
document.addEventListener("DOMContentLoaded", async function() {
    await formatSizes();
    await updateVariants();
});

window.addEventListener('load', async() => {
  initializeRadioButtons();
  await updateVariants();
  await formatSizes();
});